import * as React from "react";
import {useEffect, useState} from "react";
import OcationItem from "./OcationItem";
import { useLocation } from "react-router-dom";
import axios from 'axios';

interface Props {
  DeviceID: any;
  ap: any;
  search: any;
}

export const CategoryItem: React.FC<Props> = ({DeviceID, ap, search}) => {
    const [adOportunos, setAdOportunos] = useState([]);

   let location = useLocation();
   const {bc_seconds} = location.state;
   useEffect(() => {
     getadOportunos();
   }, [])

   const getadOportunos = () => {
     if(location.state.avisos) {
       setAdOportunos(location.state.avisos);
       postImpressionAds(location.state.avisos);
     }
   }

   const postImpressionAds = async(avisos) => {
     try {
       const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignIDs: avisos.map(v => v.CampaignID),
            MediaType: "banner"
        };
      await axios.post("/impressions", { fields, batch: true });
    } catch (error) {
        
    }
}
   
  
  return (
    <div
      className="row w-100"
      style={{
        maxWidth: "700px",
      }}
    >
      <div
        className="col-12"
        style={{
          backgroundColor: "#dc3545",
        }}
      >
        <h3 className="m-1" style={{ color: "#fff" }}>
          {location.state.header}
        </h3>
      </div>
      <div className="col-12 pt-1">
       {
           adOportunos.map((ad) => (
               <div className="p-1">
                   <OcationItem key={ad.id} ocationAd={ad} DeviceID={DeviceID} ap={ap} search={search} avisos={location.state.avisos}/>
               </div>
           ))
       }
      </div>
    </div>
  );
};
